import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { isNativeApp } from "@/lib/utils";

export default function OfflineOverlay() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (!isNativeApp() || !offline) return null;
  return (
    <div
      data-testid="offline-overlay"
      className="fixed inset-0 z-[9998] bg-black flex flex-col items-center justify-center gap-7 px-8 text-center"
    >
      <img src="/logo-fripri-splash.svg" alt="Fripri" className="w-44 max-w-[55vw]" />
      <div className="w-14 h-14 flex items-center justify-center border-2 border-[#A4D955]">
        <WifiOff size={26} color="#A4D955" strokeWidth={2.5} />
      </div>
      <div>
        <h1 className="text-white font-black text-xl uppercase tracking-wide mb-2">Pas de connexion</h1>
        <p className="text-white/60 text-sm leading-relaxed max-w-[280px] mx-auto">
          Vérifie ta connexion internet, Fripri revient dès que tu es en ligne.
        </p>
      </div>
      <button
        data-testid="offline-retry-btn"
        onClick={() => window.location.reload()}
        className="bg-[#A4D955] text-black font-bold uppercase text-xs tracking-widest px-8 py-3 border-2 border-[#A4D955] active:opacity-80"
      >
        Réessayer
      </button>
    </div>
  );
}
